import React from 'react';
import { observer } from 'mobx-react';
import { Trans, withNamespaces } from 'react-i18next';

import Heading from 'components/Heading';
import Tooltip from 'components/Tooltip';

import {
  Wrapper,
  ButtonStyled,
  ParagraphStyled,
  IconStyled,
} from 'apps/home/pricing/views/plan.styles';

export const Plan = withNamespaces()(
  observer(
    ({
      title,
      color,
      optionOne,
      buttonText,
      buttonDisabled,
      buttonHandler,
      hasFreeTrial,
    }) => (
      <Wrapper color={color}>
        <Heading level='3' align='center' weight='regular' margin='medium 0'>
          <Trans>{title}</Trans>
        </Heading>
        {optionOne}
        <ButtonStyled
          appearance='hero'
          variant={
            color === 'wfYellow'
              ? 'warning'
              : color === 'wfBlack'
              ? 'tertiary'
              : 'primary'
          }
          onClick={buttonHandler}
          text={buttonText}
          disabled={buttonDisabled}
          icon='arrow_right'
          outline={color === 'wfBlack'}
        />
        {hasFreeTrial && (
          <>
            <Tooltip html={true} />
            <ParagraphStyled size='small' variant='tertiary'>
              <Trans>No credit card required</Trans>
              <IconStyled
                name='info'
                data-tip='30 Days. Unlimited private collaborators.'
              />
            </ParagraphStyled>
          </>
        )}
      </Wrapper>
    ),
  ),
);
